// extracted by mini-css-extract-plugin
export default {"list":"tracker-attributes-list_list__vCEmZ"};